import { render, staticRenderFns } from "./OrderFormStep6.module.vue?vue&type=template&id=6c56c569&scoped=true&"
import script from "./OrderFormStep6.module.vue?vue&type=script&lang=js&"
export * from "./OrderFormStep6.module.vue?vue&type=script&lang=js&"
import style0 from "./OrderFormStep6.module.vue?vue&type=style&index=0&id=6c56c569&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c56c569",
  null
  
)

export default component.exports